import ProfileDetailUserDataTransactions from './ProfileDetailUserDataTransactions';

export default ProfileDetailUserDataTransactions;
